import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useShopStore } from '../../../redux/shop/facade';
import { useStorefrontBranding } from '../../../redux/branding/facade';
import { shopPublicService } from '../../../services/shop-public.service';
import { StorefrontCheckoutComponent } from '../components/storefront-checkout.component';
import { CheckoutFormFields, checkoutFormInitialValues } from '../../../forms/storefront/checkout.form';

export const StorefrontCheckoutContainer: React.FC = () => {
    const { cart, cartTotal, setPendingProforma } = useShopStore();
    const { currencyPrefix } = useStorefrontBranding();

    const [isFetching, setIsFetching] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);

    const { control, register, handleSubmit, formState: { errors } } = useForm<CheckoutFormFields>({
        defaultValues: checkoutFormInitialValues,
    });

    const onSubmit = async (data: CheckoutFormFields) => {
        setIsFetching(true);
        setErrorMessage(undefined);
        try {
            const response = await shopPublicService.checkout(data.email, cart);
            if (response.results.paymentUrl) {
                // Record the created proforma + its paymentUrl (persisted) so an abandoned
                // payment can be resumed via a pay-again path instead of rebuilding the cart
                // and creating a duplicate order. The cart is cleared on *confirmed* payment
                // (the confirmation screen), not here on redirect.
                setPendingProforma({
                    paymentUrl: response.results.paymentUrl,
                    proforma: response.results.proforma,
                });
                window.location.href = response.results.paymentUrl;
                // Do not reset isFetching — the page is navigating away
                return;
            }
        } catch (e: any) {
            setErrorMessage(e?.errorMessage ?? e?.message ?? 'Checkout failed. Please try again.');
        }
        setIsFetching(false);
    };

    return (
        <StorefrontCheckoutComponent
            cart={cart}
            cartTotal={cartTotal}
            currencyPrefix={currencyPrefix}
            isFetching={isFetching}
            errorMessage={errorMessage}
            control={control}
            register={register}
            errors={errors}
            handleSubmit={handleSubmit}
            onSubmit={onSubmit}
        />
    );
};

export default StorefrontCheckoutContainer;
